import {
  LABOGRUPO_SUCCESS,
  LABOGRUPO_CENTROS,
  LABOGRUPO_LOADING,
  LABOGRUPO_ERROR,
  LABOGRUPO_RESET,
} from "../../ActionTypes";

import axiosInstance from "../../../../global/helpers/axiosInstance";

export const laboGrupo = () => (dispatch) => {
  dispatch({
    type: LABOGRUPO_LOADING,
  });
  axiosInstance().then((respuesta) => {
    respuesta
      .get(`/laboratorio/grupoestudio`)
      .then((res) => {
        dispatch({
          type: LABOGRUPO_SUCCESS,
          payload: res.data,
        });
      })
      .catch((err) => {
        let error = {
          detail: err.response
            ? err.response.data
            : "Error al contactar el server.",
        };

        dispatch({
          type: LABOGRUPO_ERROR,
          payload: error,
        });
      });
  });
};

export const wsGetLaboCentros = (nextStep) => (dispatch) => {
  dispatch({
    type: LABOGRUPO_LOADING,
  });

  axiosInstance().then((respuesta) => {
    respuesta
      .get(`/laboratorio/centros`)
      .then((res) => {
        dispatch({
          type: LABOGRUPO_CENTROS,
          payload: res.data,
        });
        if (nextStep) nextStep(true, res.data);
      })
      .catch((err) => {
        let error = {
          detail: err.response
            ? err.response.data
            : "Error al contactar el server.",
        };

        dispatch({
          type: LABOGRUPO_ERROR,
          payload: error,
        });
        if (nextStep) nextStep(false, err.response.data);
      });
  });
};

export const resetLaboGrupo = () => (dispatch) => {
  dispatch({
    type: LABOGRUPO_RESET,
  });
};
